import {gql} from "@apollo/client";
import {createEstablishmentMutation, getAllEstablishmentsQuery} from "./establishmentGql";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";


const common = `
  id
  name
`

export const getChartCategoriesQuery = () => {

  return gql`
    query {
      getChartCategories {
        ${common}
      }
    }
  `;
}

export const getChartCategoryQuery = (chartCategoryId) => {

    return gql`
    query {
      getChartCategory(chartCategoryId: "${chartCategoryId}") {
        ${common}
      }
    }
  `;
}

export const createChartCategoryMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        [] );
    return gql`mutation {
      addChartCategory(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateChartCategoryMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        ["groupBy"] );
    return gql`mutation {
      updateChartCategory(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteChartCategoryMutation = (ids) => {
    var idsString =  JSON.stringify(ids);

    return gql`
    mutation {
      bulkDeleteChartCategory(chartCategoryIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addDataChartCategoryToCache = async (datas) => {
    if (!datas) {
        return
    }
    const query = getChartCategoriesQuery();
    const data = await executeQueryUtil(query);

    if (data) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartCategories: [...data.data.getChartCategories, ...datas]
            },
        });
    }
}

export const deleteChartCategoryFromCache = async (ids) => {
    const query = getChartCategoriesQuery();
    const res = await executeQueryUtil(query);
    const newData = res.data.getChartCategories.filter(item =>
        !ids.includes(item.id)
    )

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartCategories: [...newData]
            },
        });
    }
}






